import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        margin: '30px 0'
    },
    inline: {
        display: 'inline',
        fontSize: '19px'
    },
    avatar: {
        width: 60,
        height: 60,
    }
});

const SelectAccountView = ({ accounts, setAccount, classes }) => {
    return (
        <List className={classes.root}>
            {accounts.map((account, idx) =>
                <Fragment key={idx}>
                    <ListItem style={{ cursor: 'pointer' }} className='my-16' onClick={() => setAccount(account)}>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar} alt="Kanin logo" src="assets/images/logos/kanin_v.png" />
                        </ListItemAvatar>
                        <ListItemText
                            primary="Select account"
                            secondary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inline}
                                        color="primary"
                                    >
                                        {account.accountUrl}
                                    </Typography>
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </Fragment>
            )}
        </List>
    )
};

SelectAccountView.propTypes = {
    accounts: PropTypes.array,
    setAccount: PropTypes.func,
    classes: PropTypes.object
};

export default withStyles(styles)(SelectAccountView);


// WEBPACK FOOTER //
// ./src/main/content/select-account/SelectAccountView.js